import { Button, Drawer, Input, InputNumber } from "antd";
import { useState, useRef } from "react";

export default function CartDrawer({ setOpenDrawer }) {
  const [open, setOpen] = useState(true);

  const [placement, setPlacement] = useState("left");

  const onClose = () => {
    setOrderQuantity(1);
    setOpen(false);
    setOpenDrawer(false);
  };
  const onChange = (e) => {
    setPlacement(e.target.value);
  };

  const { TextArea } = Input;

  const [orderQuantity, setOrderQuantity] = useState(1);

  const cart = useRef(JSON.parse(localStorage.getItem("cart")) || []);

  const setCart = useState();
  return (
    <Drawer
      title="Cart"
      placement="right"
      closable={false}
      onClose={onClose}
      open={open}
      key={placement}
    >
      
    </Drawer>
  );
}
